import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const saveSurvey = async (params: object) => {
  return await POST({ url: Api.saveSurvey, data: params.survey, showError: false })
}
